import { render } from "./DataHub.vue?vue&type=template&id=76432bc8&scoped=true"
import script from "./DataHub.vue?vue&type=script&lang=js"
export * from "./DataHub.vue?vue&type=script&lang=js"

import "./DataHub.vue?vue&type=style&index=0&id=76432bc8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76432bc8"]])

export default __exports__